<template>
  <div>
    <ModuleHeader>Reporte Transportación</ModuleHeader>
    <v-row>
      <v-col md="12">
        <v-card>
          <v-card-text>
            <p class="text-subtitle-1">Filtros</p>
            <v-row>
              <v-col md="6">
                <label>Fecha inicial</label>
                <Datepicker
                  @selected="selectDate"
                  :value="input_date.format('MM/DD/YYYY')"
                ></Datepicker>
              </v-col>
              <v-col md="6">
                <label>Fecha final</label>
                <Datepicker
                  @selected="selectDateFinal"
                  :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"
                ></Datepicker>
              </v-col>
              <v-col md="6">
                <v-autocomplete label="Mayorista" v-model="selectedHotel" :items="comp_hotel"></v-autocomplete>
              </v-col>
              <v-col md="12">
                  <v-btn
                    @click="getReservas"
                    color="green"
                    dark
                  >
                    Buscar
                  </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-simple-table>
          <thead>
            <tr>
              <th>Folio</th>
              <th>Cliente</th>
              <th>Hotel PickUp</th>
              <th>Golf Course Pickup (Return)</th>
              <th>Duracion de viaje</th>
              <th>Afiliado</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="reservations.length == 0">
              <td colspan="7">No se encontraron datos</td>
            </tr>
            <template v-for="(res, index) in reservas_comp">
              <tr :key="index">
                <td>{{ res.Transportacion.Confirmacion }}</td>
                <td>{{ res.Cliente.Nombre }}</td>
                <td>{{ res.ida_format }}</td>
                <td>{{ res.regreso_format }}</td>
                <td>{{ res.Transportacion.DuracionViaje }}</td>
                <td>{{ res.NombreHotel }}</td>
                <td>${{ res.Transportacion.Total }} USD</td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<style >
</style>


<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "repo_transportacion",
  components: {
    Datepicker,
  },
  props: [],
  data() {
    return {
      MainDepartamento: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      showModal: false,
      formKey: 0,
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      reservations: [],
    };
  },
  methods: {
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getHorarios() {
      const data = await this.$store.getters.getFirebaseApp.database
        .queryBuilder("RVA/Tarifas/" + this.MainDepartamento + "/Horarios")

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      await this.$store.getters.getFirebaseApp.database
        .queryBuilderListener("RVA/Mayoristas/Coleccion",null,
        (snapshot) => {
          this.hoteles = [];
          let arrayHoteles = Object.entries(snapshot.val());
          arrayHoteles.forEach((element) => {
            this.hoteles.push({ id: element[0], ...element[1] });
          });
        }
        )
    },
    deletHotel(idHotel) {
      this.$swal({
        title: "¿Deseas eliminar este Hotel?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { hId: idHotel };
          return await this.$store.getters.getFirebaseApp.fba
            .call("Golf-Hoteles-eliminarHotel", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Hotel elimando",
              "El hotel se elimino correctamente",
              "success"
            );
            this.$emit("changeIndex");
          } else {
            this.$swal("Error saving data", "Your data didnt save", "error");
          }
        }
      });
    },
    successData(data) {
      let duration =
        data.duracion.horas.toString().padStart(2, "0") +
        ":" +
        data.duracion.minutos.toString().padStart(2, "0") +
        ":00";
      let dataHotel = {
        hotelCode: data.codigo,
        hotelName: data.nombre,
        duracionViaje: duration,
      };
      this.saveHotel(dataHotel);
    },
    saveHotel(data) {
      this.$swal({
        title: "Deseas guardar el hotel?",
        text: "El Hotel se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("Golf-Hoteles-crearHotel", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Hotel Guardado",
              "El hotel se almaceno correctamente",
              "success"
            );

            this.showModal = false;
            this.formKey++;
          } else {
            this.$swal("Error saving data", "Your data didnt save", "error");
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getReservas() {
      this.loadingData = true;
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );

      const firestore = this.$store.getters.getFirebaseApp.firestore
      let filters = [
        firestore.where("RF.FI", ">=", startDate),
        firestore.where("RF.FI", "<", end),
        firestore.where("Tenant", "==", this.$store.getters.getFirebaseApp.tenant)
      ]

      if (this.selectedHotel !== "") {
        if (this.selectedHotel !== "Admin" && this.selectedHotel !== "Web") {
          filters.push(firestore.where("Accesos", "array-contains", this.selectedHotel));
          filters.push(firestore.where("Creador", "==", "Hotel"));
        } else {
          filters.push(firestore.where("Creador", "==", this.selectedHotel));
        }
      }

      const data = await firestore
        .queryBuilder(
          "RVA_Reservas",
          filters
        );

      this.reservations = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      this.showEstad = true;
      this.loadingData = false;

      this.reservations.forEach((element) => {
        let tarifas = Object.entries(element.Tarifas);
        element.TarifasList = tarifas;
      });
    },
  },
  computed: {
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    reservas_comp() {
      let res = [];
      this.reservations.forEach((ele) => {
        if (ele.Transportacion) {
          this.$pgsHelper.log(ele.Transportacion);
          let format_date = moment(ele.Fecha, "YYYY-MM-DD_HH:mm:ss");
          let ida_date = moment(
            ele.Transportacion.HtlPickUpDateTime,
            "YYYY-MM-DD_HH:mm:ss"
          );
          let regreso_date = moment(
            ele.Transportacion.PCGCPickUpDateTime,
            "YYYY-MM-DD_HH:mm:ss"
          );
          ele.date_format = format_date.format("DD-MM-YYYY");
          ele.time_format = format_date.format("HH:mm");
          ele.ida_format = ida_date.format("DD-MM-YYYY HH:mm");
          ele.regreso_format = regreso_date.format("DD-MM-YYYY HH:mm");
          if (ele.TipoCreador === "Hotel") {
            let index = this.$_.findIndex(this.hoteles, [
              "Codigo",
              ele.Accesos[0],
            ]);
            ele.NombreHotel = this.hoteles[index].Nombre;
          } else {
            ele.NombreHotel = "Campo de golf";
          }
          res.push(ele);
        }
      });

      return res;
    },
    total() {
      let total = 0;
      this.reservations.forEach((ele) => {
        if (ele.Transportacion) {
          total = total + ele.Transportacion.Total;
        }
      });
      var formatter = new Intl.NumberFormat("en-US");

      return formatter.format(total);
    },
    golfClub() {
      let golf = 0;
      this.reservations.forEach((ele) => {
        let index = this.$_.findIndex(ele.Addons, ["Id", "GolfClub"]);
        if (index >= 0) {
          golf = golf + ele.Addons[index].Cantidad;
        }
      });
      return golf;
    },
    extraRider() {
      let golf = 0;
      this.reservations.forEach((ele) => {
        let index = this.$_.findIndex(ele.Addons, ["Id", "ExtraRidder"]);
        if (index >= 0) {
          golf = golf + ele.Addons[index].Cantidad;
        }
      });
      return golf;
    },
    comp_hotel() {
      let hotel = [
        { id: "", text: "Todos" },
        { id: "Admin", text: "Administrador" },
        { id: "Web", text: "Sitio Web" },
      ];
      this.hoteles.forEach((ele) => {
        hotel.push({ id: ele.Codigo, text: ele.Nombre });
      });
      return hotel;
    },
  },
  watch: {},
  mounted() {},
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getHorarios();
    this.getHoteles();
  },
};
</script>